import { PAGES } from "../constants";

export const ALL_ORGANIZATIONS = `${PAGES} [AllOrganizations]`;
export const ORGANIZATION_FORM = `${PAGES} [OrganizationForm]`;

export const START_NEW_ORGANIZATION_SCREEN = `${ORGANIZATION_FORM} START`;
export const SAVE_ORGANIZATION = `${ORGANIZATION_FORM} SAVE_ORGANIZATION`;
export const START_ALL_ORGANIZATIONS_SCREEN = `${ALL_ORGANIZATIONS} START`;

export const startNewOrganizationScreen = () => ({
  type: START_NEW_ORGANIZATION_SCREEN,
});

export const saveOrganization = ({ organization }) => ({
  type: SAVE_ORGANIZATION,
  payload: { organization },
});

export const startAllOrganizationsScreen = () => ({
  type: START_ALL_ORGANIZATIONS_SCREEN,
});
